import { Stack } from "@fluentui/react";
import React, { useState } from "react";

import { AnimatedCommandBarButton } from "../../inputs/button/AnimatedCommandBarButton";
import { useScrollNavigation } from "./useScrollNavigation";

export type ScrollNavigationMenuItem = {
    id: string;
    label: string;
};

interface ScrollNavigationMenuProps {
    items: ScrollNavigationMenuItem[];
}

export const ScrollNavigationMenu = ({ items }: ScrollNavigationMenuProps): JSX.Element => {
    const { scrollTo } = useScrollNavigation();
    const [selectedItem, setSelectedItem] = useState<string | undefined>(items[0]?.id);

    const onClick = (id: string) => {
        setSelectedItem(id);
        scrollTo(id);
    };

    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 0 }}>
            {items.map((item) => (
                <>
                    <AnimatedCommandBarButton
                        selected={selectedItem === item.id}
                        onClick={() => onClick(item.id)}
                        text={item.label}
                    />
                </>
            ))}
        </Stack>
    );
};
